import { render, staticRenderFns } from "./myCollectPolicy.vue?vue&type=template&id=85f94c66&scoped=true"
import script from "./myCollectPolicy.vue?vue&type=script&lang=js"
export * from "./myCollectPolicy.vue?vue&type=script&lang=js"
import style0 from "./myCollectPolicy.vue?vue&type=style&index=0&id=85f94c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f94c66",
  null
  
)

export default component.exports